

export enum RoleType {
  TEAMLEAD   = 'teamlead',
  TECHLEAD   = 'techlead',
  DEVELOPER  = 'developer',
  SPECIALIST = 'specialist',
  SRE        = 'sre',
}

export const VisibleRoles = [
  RoleType.TECHLEAD,
  RoleType.TEAMLEAD,
];
